import { TemplateData, TemplateDataServer } from 'interfaces/api/templates.interfaces'

export const toServerTemplatedData = (data: TemplateData): TemplateDataServer => ({
  title: {
    en: data.title,
    ru: data.title,
  },
  code: data.code,
  ...(data.flex ? { flex: data.flex } : {}),
})
